import CloseIcon from "@mui/icons-material/Close";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { useTranslation, Trans } from "react-i18next";

interface Props {
  isOpen: boolean;
  handleClose: () => void;
}

export default function TermsAndConditionsDialog({
  isOpen,
  handleClose,
}: Props) {
  const { t } = useTranslation();

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="terms-and-conditions-dialog-title"
      open={isOpen}
    >
      <DialogTitle sx={{ m: 0, p: 2 }} id="terms-and-conditions-dialog-title">
        {t("termsAndConditions.title")}
      </DialogTitle>
      <IconButton
        aria-label={t("termsAndConditions.close")}
        onClick={handleClose}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <Stack spacing={2}>
          <Typography variant="h5">
            {t("termsAndConditions.heading")}
          </Typography>
          <Typography variant="h6">
            {t("termsAndConditions.general.subheading")}
          </Typography>
          <Typography>
            <Trans i18nKey="termsAndConditions.general.body" />
          </Typography>
          <Typography variant="h6">
            {t("termsAndConditions.conditions.subheading")}
          </Typography>
          <Typography variant="h6">
            {t("termsAndConditions.conditions.parties.subheading")}
          </Typography>
          <Typography>
            <Trans i18nKey="termsAndConditions.conditions.parties.body" />
          </Typography>
          <Typography variant="h6">
            {t("termsAndConditions.conditions.subject.subheading")}
          </Typography>
          <Typography>
            <Trans i18nKey="termsAndConditions.conditions.subject.body" />
          </Typography>
          <Typography variant="h6">
            {t("termsAndConditions.conditions.content.subheading")}
          </Typography>
          <Typography>
            <Trans i18nKey="termsAndConditions.conditions.content.body" />
          </Typography>
          <Typography variant="h6">
            {t("termsAndConditions.conditions.terms.subheading")}
          </Typography>
          <Typography>
            <Trans i18nKey="termsAndConditions.conditions.terms.body" />
          </Typography>
          <Typography variant="h6">
            {t("termsAndConditions.conditions.otherTerms.subheading")}
          </Typography>
          <Typography>
            <Trans i18nKey="termsAndConditions.conditions.otherTerms.body" />
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleClose}>
          {t("termsAndConditions.close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
